import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../services/AuthContext";
import axios from "axios";
import { Link } from "react-router-dom";
import styles from "../../styles/UserProfile.module.css";
import likeStyles from "../../styles/Like.module.css";
import getPostStyles from "../../styles/GetPostForm.module.css";
import { toast } from "react-toastify";
import Sorting from "../../services/Sorting";
import Like from "./Like";
import CommentsSection from "./CommentsSection";
import { TbCalendarDown, TbCalendarUp } from "react-icons/tb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Images from "../../services/Images";
import {
  faTrash,
  faSortUp,
  faSortDown,
  faCalendarAlt,
  faComment,
} from "@fortawesome/free-solid-svg-icons";
import { MdOutlineInsertComment } from "react-icons/md";

function GetPostForm() {
  const [posts, setPosts] = useState([]);
  const { login } = useContext(AuthContext);
  const [order, setOrder] = useState("newest");
  const [visibleCommentsPostId, setVisibleCommentsPostId] = useState(null);

  useEffect(() => {
    getAllPosts();
    onGetImage();
  }, [order]);

  const sortNew = () => {
    let ordered = Sorting.sortPosts("newest", [...posts]);
    setPosts(ordered);
    setOrder("newest");
  };

  const sortOld = () => {
    let ordered = Sorting.sortPosts("oldest", [...posts]);
    setPosts(ordered);
    setOrder("oldest");
  };

  const onDelete = async (id) => {
    const conferma = window.confirm("Sei sicuro di voler cancellare il post?");
    if (conferma) {
      let response = await axios.delete(
        process.env.REACT_APP_SERVER_URL + "posts/${id}",
        {
          headers: {
            authToken: localStorage.getItem("AuthToken"),
          },
        }
      );

      toast.success("Post cancellato!", {
        onClose: () => {
          setPosts(posts.filter((post) => post.id !== id));
        },
        autoClose: 3000,
      });
    }
  };

  const toggleComments = (postId) => {
    if (visibleCommentsPostId === postId) {
      setVisibleCommentsPostId(null);
    } else {
      setVisibleCommentsPostId(postId);
    }
  };

  const incrementCommentCount = (postId) => {
    setPosts((prevPosts) =>
      prevPosts.map((post) =>
        post.id === postId
          ? { ...post, commentsCount: (post.commentsCount || 0) + 1 }
          : post
      )
    );
  };

  const onGetImage = async (key) => {
    let getImage = await Images.getPostImages(key);
    console.log("Key: ", key);
    console.log("Image: ", getImage);
  };

  const getAllPosts = async () => {
    let response = await axios.get(process.env.REACT_APP_SERVER_URL + "posts", {
      headers: {
        authToken: localStorage.getItem("AuthToken"),
      },
    });

    if (response?.data?.error) {
      console.log(response.data.error);
    } else {
      console.log("RISPOSTA: ", response.data);
      if (response?.data) {
        console.log("Key: ", response?.data);
      }
      setPosts(Sorting.sortPosts(order, response.data));
    }
  };

  return (
    <div className={styles.contents}>
      <div className={styles.header}>
        <div className={styles.pageTitle}>
          <h1>SHOW POSTS</h1>
          <div className={styles.buttoncontainer}>
            <button type="button" onClick={sortNew} title="Sort by newest">
              <TbCalendarUp
                style={{
                  color: order === "newest" ? "#4660b0" : "white",
                  cursor: order === "newest" ? "not-allowed" : "pointer",
                  fontSize: "24px",
                }}
              />
            </button>

            <button type="button" onClick={sortOld} title="Sort by oldest">
              <TbCalendarDown
                style={{
                  color: order === "oldest" ? "#4660b0" : "white",
                  cursor: order === "oldest" ? "not-allowed" : "pointer",
                  fontSize: "24px",
                }}
              />
            </button>
          </div>
        </div>
        <text> Sorted by {order === "newest" ? " newest" : " oldest"}</text>
      </div>
      <div className={getPostStyles.container}>
        {posts.map((post) => {
          const isOwner = post?.user?.username === login?.username;
          const userLike =
            post.likes && post.likes.length > 0 ? post.likes[0].like : false;

          console.log("Image: ", post.postImage);

          return (
            <div className={getPostStyles.post} key={post.id}>
              <p>
                <Link
                  title="Go to profile"
                  href
                  to={"/User/${post?.user?.username}"}
                  style={{
                    textDecoration: "none",
                    color: "#4660b0",
                    active: "green",
                  }}
                >
                  {post?.user?.username}
                </Link>
              </p>
              <p>{post?.title}</p>
              <p>{post?.post}</p>
              <p>
                Created:{" "}
                {new Date(post.createdAt)
                  .toLocaleString("it-IT", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                  .replace(",", " at")}
              </p>

              {isOwner ? (
                <div className={likeStyles.like}>
                  <div className={likeStyles.numlike}>
                    <button
                      type="button"
                      onClick={() => onDelete(post.id)}
                      title="Delete Post"
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        style={{ fontSize: "12pt" }}
                      />
                    </button>
                    <button
                      style={{ marginLeft: "20px", fontSize: "14pt" }}
                      type="button"
                      onClick={() => toggleComments(post.id)}
                      title="Show/Hide Comments"
                    >
                      <MdOutlineInsertComment />
                      <span style={{ marginLeft: "0px", fontSize: "10pt" }}>
                        {post.commentsCount || 0}
                      </span>
                    </button>
                    <Like isOwner={isOwner} />
                  </div>
                  {visibleCommentsPostId === post.id && (
                    <div className={likeStyles.like}>
                      <CommentsSection
                        postId={post.id}
                        isOwner={isOwner}
                        onCommentAdded={() => incrementCommentCount(post.id)}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div className={likeStyles.like}>
                  <div className={likeStyles.numlike}>
                    <button
                      style={{ marginLeft: "20px", fontSize: "10pt" }}
                      type="button"
                      onClick={() => toggleComments(post.id)}
                      title="Show/Hide Comments"
                    >
                      <MdOutlineInsertComment />
                      <span style={{ marginLeft: "0px", fontSize: "10pt" }}>
                        {post.commentsCount || 0}
                      </span>
                    </button>
                    <Like postId={post.id} userLike={userLike} />
                  </div>
                  {visibleCommentsPostId === post.id && (
                    <div className={likeStyles.like}>
                      <CommentsSection
                        postDate={post.createdAt}
                        postId={post.id}
                        onCommentAdded={() => incrementCommentCount(post.id)}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GetPostForm;
